import React, { Component } from 'react';
import queryString from 'querystring';
import { API_BASE_URL } from '../constatns';

class PrivacyPolicyJA extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.location.href = 'https://ajaxjp.com/privacy/';
  }

  render() {
    return <div className="share-container">&nbsp;</div>;
  }
}

export default PrivacyPolicyJA;
